import { environment } from '../../environments/environment';

export const App = {
    name: 'Aware Admin',
    api_url: environment.api.url,
    language: 'da',
    location: 'dk',
    module: '',
    defaultModule: 'cms',
    source: environment.api.source,
    unit: environment.api.unit,
    tempUnit: null,
    org: environment.api.unit,
    content_type: 'application/x-www-form-urlencoded;charset=utf-8',
    timezone: 'Europe/Stockholm',
    language_strict: false,
    language_fallback: 'en',
    app: '',
};
